export const pageConstants = {
    NEXT : 'NEXT_PAGE',
    CURRENT : 'CURRENT_PAGE',
    PREVIOUS: 'PREVIOUS_PAGE',
    RESET: 'RESET_PAGE'
};